module.exports = __webpack_public_path__ + "img/10979915_L.c5420bc0.png";